import PropTypes from 'prop-types';

export const tutorStepPropTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  // eslint-disable-next-line react/no-unused-prop-types
  siteMap: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.string,
  })).isRequired,
};
